package devxertech.com.pages.dashboard.aboutUsSection

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.BackgroundPosition
import com.varabyte.kobweb.compose.css.BackgroundSize
import com.varabyte.kobweb.compose.css.CSSPosition
import com.varabyte.kobweb.compose.css.FontSize
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.functions.url
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.attrsModifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.backgroundPosition
import com.varabyte.kobweb.compose.ui.modifiers.backgroundSize
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.textAlign
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import devxertech.com.component.FieldTitleTextNormalSimple
import devxertech.com.theme.toSitePalette
import devxertech.com.utils.Constants
import devxertech.com.utils.Res
import kotlinx.browser.window
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.H2

@Composable
fun AboutUsSection(breakpoint: Breakpoint) {
    val sitePalette = ColorMode.current.toSitePalette()
    Column(
        modifier = Modifier
            .fillMaxWidth()
            .margin(topBottom = if (breakpoint >= Breakpoint.LG) 70.px else 20.px)
            .backgroundImage(url(Res.Image.dot_bg))
            .backgroundSize(BackgroundSize.Cover)
            .backgroundPosition(BackgroundPosition.of(CSSPosition.Center))
    )
    {

        if (breakpoint <= Breakpoint.MD) {
            Column(
                modifier = Modifier.fillMaxWidth().margin(topBottom = 40.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                SpanText(
                    "WELCOME TO DEVXER TECHNOLOGIES",
                    modifier = Modifier
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontFamily(Constants.FONT_FAMILY)
                        .textAlign(TextAlign.Center)
                        .fontSize(18.px)
                )
                H2(attrs = { style { property("display", "flex"); property("margin", "0") } }) { Row(modifier = Modifier) {
                    SpanText(
                        "About ",
                        modifier = Modifier
                            .color(sitePalette.commonSecondaryButtonColor.rgb)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 25.px)
                            .fontWeight(FontWeight.Bold)
                    )
                    SpanText(
                        "Us",
                        modifier = Modifier
                            .color(sitePalette.primary.rgb)
                            .fontFamily(Constants.FONT_FAMILY)
                            .fontSize(if (breakpoint > Breakpoint.MD) 35.px else 25.px)
                            .fontWeight(FontWeight.Bold)
                    )
                } }
                SpanText(
                    "At Devxer Technologies, we are passionate innovators dedicated to" +
                            " driving technological excellence. With a team of seasoned experts, " +
                            "we deliver cutting-edge IT solutions that empower businesses to thrive in a" +
                            " rapidly evolving digital landscape. Our commitment to quality, integrity, " +
                            "and customer success sets us apart as a trusted partner in navigating the future of technology.",
                    modifier = Modifier
                        .width(if (breakpoint == Breakpoint.MD) 600.px else if (window.screen.width < 375) 270.px else 350.px)
                        .color(sitePalette.commonSecondaryButtonColor.rgb)
                        .fontFamily(Constants.FONT_FAMILY)
                        .fontSize(FontSize.Medium)
                        .whiteSpace(WhiteSpace.PreWrap)
                        .textAlign(TextAlign.Justify)
                )

            }
        }
        Row(
            modifier = Modifier.fillMaxWidth(),
            verticalAlignment = Alignment.CenterVertically,
            horizontalArrangement = Arrangement.SpaceEvenly
        ) {
            Image(
                src = Res.Image.about_us,
                modifier = Modifier.attrsModifier { attr("alt", "Devxer Technologies team collaborating on IT solutions") }
                    .width(if (breakpoint > Breakpoint.LG) 595.px else if (breakpoint == Breakpoint.MD) 500.px else 340.px)
                    .height(if (breakpoint > Breakpoint.LG) 386.px else if (breakpoint == Breakpoint.MD) 300.px else if (window.screen.width < 375) 180.px else 258.px)
            )
            if (breakpoint > Breakpoint.MD) {
                Column(
                    modifier = Modifier.fillMaxWidth(40.percent).margin(top = 40.px),
                    horizontalAlignment = Alignment.CenterHorizontally
                ) {

                    FieldTitleTextNormalSimple(
                        "WELCOME TO DEVXER TECHNOLOGIES",
                        color = sitePalette.commonSecondaryButtonColor.rgb,
                        fontSize = 18.px,
                        textAlign = TextAlign.Center,
                    )

                    H2(attrs = { style { property("display", "flex"); property("margin", "0") } }) { Row(modifier = Modifier) {
                        FieldTitleTextNormalSimple(
                            "About",
                            color = sitePalette.commonSecondaryButtonColor.rgb,
                            fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                            fontWeight = 600,
                        )
                        FieldTitleTextNormalSimple(
                            " Us",
                            color = sitePalette.primary.rgb,
                            fontSize = if (breakpoint > Breakpoint.MD) 35.px else 20.px,
                            fontWeight = 600,
                        )
                    } }
                    FieldTitleTextNormalSimple(
                        "At Devxer Technologies, we are passionate innovators dedicated to" +
                                " driving technological excellence. With a team of seasoned experts, " +
                                "we deliver cutting-edge IT solutions that empower businesses to thrive in a" +
                                " rapidly evolving digital landscape. Our commitment to quality, integrity, " +
                                "and customer success sets us apart as a trusted partner in navigating the future of technology.",
                        width = if (window.screen.width > 1800) 900.px
                        else if (window.screen.width in 1601..1800) 900.px
                        else if (window.screen.width > 1600) 800.px
                        else 554.px,
                        color = sitePalette.commonSecondaryButtonColor.rgb,
                        fontSize = 18.px,
                        textAlign = TextAlign.Justify
                    )
                }
            }
        }
    }
}
